import {WlTree, WlTreeItem} from "./tree.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './tree.component';
export default WlTreeItem;

defineWebComponent('wl-tree', WlTree);
defineWebComponent('wl-tree-item', WlTreeItem);